<template>
  <div>
    <div class="imgBtn" @click="togglePortal">
      <img
        style="width:24px;height:24px"
        :src="require(`@/assets/icon/${hasBluetooth ? 'ble_yes' : 'ble_no'}.png`)"
        alt
      />
      <p style="color:#ffffff">Bluetooth</p>
    </div>
    <div class="box-wrapper" v-if="isPortalOpen">
      <div class="box">
        <div class="header">
          <span style="position: relative;">Choose your Bluetooth device</span>
          <div class="swal2-close" @click="togglePortal()">×</div>
        </div>

        <div class="inner">
          <div class="text">
            Please click connect
            <br />button to pair your bluetooh device.
          </div>
          <div class="buttonContainer">
            <button class="button" @click="scanAndConnect()">Connect</button>
          </div>
        </div>

        <div class="deviceList">
          <ul>
            <li
              v-for="(device, index) in connectedDevices"
              class="connected-device"
              :key="index"
              @click="disconnect(device)"
            >
              {{ device.name }}
              <span class="checkmark"></span>
            </li>
            <li
              v-for="index in preConnectionNumber"
              class="connected-device preConnect"
              :key="'preConnection' + index"
            >
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </li>
            <li
              v-for="index in emptyDevices"
              class="connected-device"
              :key="'supplement' + index"
            ></li>
          </ul>
        </div>

        <div class="footer"></div>
      </div>
    </div>
    <!-- <pre>{{ connectedDevices }}</pre> -->
  </div>
</template>

<script>
/* eslint no-param-reassign: ["error", { "props": false }] */
import { mapState, mapGetters } from 'vuex';
// eslint-disable-next-line import/extensions
import { webBleMixin } from '@/assets/webBleMixin/webBleMixin.js';

export default {
  mixins: [webBleMixin],
  data() {
    return {
      isPortalOpen: false,
    };
  },
  computed: {
    ...mapState(['connectedDevices', 'preConnectionNumber']),
    ...mapGetters(['connectionNumber']),
    emptyDevices() {
      return 4 - this.connectionNumber - this.preConnectionNumber;
    },
    hasBluetooth() {
      console.log(this.connectionNumber > 0);
      return this.connectionNumber > 0;
    },
  },
  methods: {
    togglePortal() {
      this.isPortalOpen = !this.isPortalOpen;
    },
    // below is methods for send and recieve
    // recievedCallback(value, name) {
    //   console.log(`Get message from ${name}`);
    //   console.log('handleNotifications: response', value);
    // },
    // setNotification(device) {
    //   webBleHandler.AddListener(device, this.recievedCallback);
    // },
    // async sendMessage(device) {
    //   const status = await webBleHandler.send('IntType', device, this.msgToSend);
    //   console.log(status);
    // },
  },
};
</script>

<style lang="scss" scoped>
div,
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.imgBtn {
  display: flex;
  line-height: 24px;
  align-items: center;
  p {
    margin: 0 6px;
    line-height: 35px;
  }
}
.box-wrapper {
  z-index: 1000;
  font-family: Arial;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  width: 400px;
  position: relative;
}

.header {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  background-color: white;
  color: black;
  height: 35px;
  line-height: 35px;
  display: flex;
  justify-content: center;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 14px;
  box-shadow: 0.2px 0.2px 4px 1px rgba(0, 0, 0, 0.1);
  width: 400px;
}
.swal2-close {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  -webkit-box-pack: center;
  justify-content: center;

  padding: 0;
  overflow: hidden;
  -webkit-transition: color 0.1s ease-out;
  transition: color 0.1s ease-out;
  border: none;
  border-radius: 0;
  outline: initial;
  background: 0 0;
  color: #ccc;
  font-family: serif;
  font-size: 2.5em;

  cursor: pointer;
  height: 35px;
  width: 35px;
  line-height: 35px;
  &:hover {
    color: #39e2cf;
  }
}

.inner {
  background-color: #f3f5f9;
  display: flex;
  height: 92px;
  .text {
    text-align: left;
    font-size: 15px;
    margin: auto;
    padding: 15px;
    color: black;
  }
  .buttonContainer {
    display: flex;
    margin: auto;
    padding: 0px 35px;
    button {
      padding: 0;
      color: white;
      width: 150px;
      height: 35px;
      line-height: 35px;
      align-items: center;
      border-radius: 17.5px;
      font-size: 20px;
      border: none;
      background-image: linear-gradient(to right, #39e2cf 0%, #35b6e6);
      &:hover {
        background-image: linear-gradient(to right, #23cfbb 0%, #2a9ec9);
      }
      &:focus {
        color: white;
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }
}

.deviceList {
  background-color: #fff;
  margin: 0px;
}
.connected-device {
  color: black;
  padding: 0 17px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #37ccda;
  text-align: left;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #37ccda;
    color: white;
  }
  .deviceState {
    float: right;
  }

  .checkmark {
    height: 17px;
    width: 11px;
    right: 12px;
    top: 50%;
    border-bottom: 3px solid #37ccda;
    border-right: 3px solid #37ccda;
    transform: translateY(-50%) rotate(45deg);
    display: inline-block;
    position: absolute;
  }

  &:hover {
    .checkmark {
      border-bottom: 3px solid #fff;
      border-right: 3px solid #fff;
    }
    .lds-spinner div:after {
      background: white;
    }
  }

  &.preConnect {
    .lds-spinner {
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      position: absolute;
      width: 17px;
      height: 17px;
    }
    .lds-spinner div {
      transform-origin: 8.5px 8.5px;
      animation: lds-spinner 0.8s linear infinite;
    }

    .lds-spinner div:after {
      content: " ";
      display: block;
      position: absolute;
      top: 0px;
      left: 8px;
      width: 3px;
      height: 5px;
      border-radius: 20%;
      background: #37ccda;
    }

    .lds-spinner div:nth-child(1) {
      transform: rotate(0deg);
      animation-delay: -0.7s;
    }

    .lds-spinner div:nth-child(2) {
      transform: rotate(45deg);
      animation-delay: -0.6s;
    }
    .lds-spinner div:nth-child(3) {
      transform: rotate(90deg);
      animation-delay: -0.5s;
    }
    .lds-spinner div:nth-child(4) {
      transform: rotate(135deg);
      animation-delay: -0.4s;
    }

    .lds-spinner div:nth-child(5) {
      transform: rotate(180deg);
      animation-delay: -0.3s;
    }

    .lds-spinner div:nth-child(6) {
      transform: rotate(225deg);
      animation-delay: -0.2s;
    }

    .lds-spinner div:nth-child(7) {
      transform: rotate(270deg);
      animation-delay: -0.1s;
    }
    .lds-spinner div:nth-child(8) {
      transform: rotate(315deg);
      animation-delay: 0s;
    }
    @keyframes lds-spinner {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
}

.footer {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #f3f5f9;
  padding: 16px 0;
}
</style>
